export const bookingConstraints = [
  { label: 'Not available business hours (8am-5pm)', value: 'no_business_hours' },
  { label: 'Not available evenings (5pm-9pm)', value: 'no_evenings' },
  { label: 'Not available weekends (Sat. and Sun.)', value: 'no_weekends' },
  { label: 'I am flexible', value: 'no_restrictions' },
];
